/**
 * @generated SignedSource<<561bf842486ed04af96052eb1fba1105>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_links$data = ReadonlyArray<{
  readonly anchorText: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "SharedMobileLinksBlock_links";
}>;
export type SharedMobileLinksBlock_links$key = ReadonlyArray<{
  readonly " $data"?: SharedMobileLinksBlock_links$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_links">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedMobileLinksBlock_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorText",
      "storageKey": null
    }
  ],
  "type": "InternalBuyLinkType",
  "abstractKey": null
};

(node as any).hash = "b874354a2f6be93bf31a6cf3252d5c8e";

export default node;
